(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal
    const providers = {}

    function register(name, provider) {
        if (!name || !provider || typeof provider.send !== 'function') {
            return false
        }

        providers[name] = provider
        return true
    }

    function isReady(delivery) {
        const provider = providers[delivery.provider]
        if (!provider) {
            return false
        }

        if (typeof provider.isReady !== 'function') {
            return true
        }

        try {
            return !!provider.isReady(delivery)
        } catch (error) {
            return false
        }
    }

    function send(delivery) {
        const provider = providers[delivery.provider]
        if (!provider) {
            return Promise.resolve(false)
        }

        try {
            return Promise.resolve(provider.send(delivery)).then(function(result) {
                return result !== false
            }).catch(function() {
                return false
            })
        } catch (error) {
            return Promise.resolve(false)
        }
    }

    internal.providers = Object.freeze({
        register: register,
        isReady: isReady,
        send: send
    })
})(window)
